import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
Date.formatToTimeString = function(milliseconds) {
	var totalSeconds = Math.round(milliseconds / 1000);
	var minutes = Math.floor(totalSeconds / 60);
	var seconds = totalSeconds % 60;

	// Converting 0:60 to 1:00
	if (seconds === 60) {
		seconds = 0;
		minutes++;
	}

	if (minutes < 10) {
		minutes = "0" + minutes;
	}
	if (seconds < 10) {
		seconds = "0" + seconds;
	}

	return `${minutes}:${seconds}`;
};
ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js